import { DropdownItem } from "../shared/checkbox-dropdown";

interface ManageResourceTagDisplayModel {
  key: string;

  tagGroupName: string,
  tagName: string,
  projectName: string,
  templateName: string,

  projectCount: number,
  groupCount: number,
  tagCount: number,

  resourceTagIds: string[],
}

enum Perspectives {
  Group = "Group",
  Tag = "Tag",
  Project = "Project",
  All = "All"
}

const ResourceTagFilterDropdownItems: Array<DropdownItem<Perspectives>> = [
  { // key relates it to Perspectives enum, but name is purely for display stuff
    key: Perspectives.Group,
    name: "Group",
  },
  {
    key: Perspectives.Tag,
    name: "Tag",
  },
  {
    key: Perspectives.Project,
    name: "Project",
  },
];

interface ResourceTagViewerProps {
  perspective: keyof typeof Perspectives,
  searchValue: string,
  showXRows: number,
  take: number,
}

interface ResourceTagViewerState {
  loading: boolean;
  perspective: string;
  resourceTags: ManageResourceTagDisplayModel[];
  tableRows: ManageResourceTagDisplayModel[];
  take: number;
  searchValue: string;
  showXRows: number;
  selectedRows: ManageResourceTagDisplayModel[];
  deleteConfirmationModalIsOpen: boolean;
}

export {
  ManageResourceTagDisplayModel,
  Perspectives,
  ResourceTagFilterDropdownItems,
  ResourceTagViewerProps,
  ResourceTagViewerState,
}